import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import ButtonWrapper from "../../components/Button";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { FaFilePdf } from "react-icons/fa";
import { Loader } from "@egovernments/digit-ui-react-components";

const Step4 = ({ formData, handleTabChange, isEmployee, isNocModule }) => {
  const { t } = useTranslation();
  const { handleSubmit, control, setValue, watch, reset } = useForm({});
  const drawingDetail = formData?.drawingDetail || [];
  const [open, setOpen] = useState(false);
  const [signingParams, setSigningParams] = useState({
    AuthToken: "",
    SrcPdfB64: "",
    SignSettingName: "",
    ReturnUrl: "",
    UserDataJson: "",
  });
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const onSubmit = (data) => {
    OpenPDFFromB64InPdfViewer();
  };

  // Define the columns you want to display
  const columns = [
    { id: "submissionIndex", label: "Submission", accessor: "" }, // New column for submission index
    { id: "drawingPdf", label: "Drawing PDF", accessor: "updatedDxfFile" },
    { id: "planReport", label: "Plan Report", accessor: "planReport" },
    { id: "dxfFile", label: "DXF File", accessor: "dxfFile" },
    { id: "status", label: "Status", accessor: "status" },
    { id: "submittedOn", label: "Submitted On", accessor: "submittedOn" },
    { id: "signedPdfUrl", label: "Digital Sign", accessor: "signedPdfUrl" },
  ];
  const handleClose = () => {
    setOpen(false);
  };
  const handleSign = async () => {
    setLoading(true);
    try {
      const SignRequest = {
        applicationNo: formData?.applicationNo,
        pdfType: "D",
      };
      const getSign = await Digit.DscService.getSignParams({ SignRequest });
      setSigningParams((prev) => ({
        ...prev,
        AuthToken: getSign?.SigningParameters?.authToken,
        SrcPdfB64: getSign?.SigningParameters?.pdfBase64,
        SignSettingName: getSign?.SigningParameters?.signSettingName,
        ReturnUrl: getSign?.SigningParameters?.returnURL,
        UserDataJson: getSign?.SigningParameters?.UserDataJson,
      }));
      setOpen(true);
      setLoading(false);
      console.log({ getSign, signingParams, AuthToken, SrcPdfB64, SignSettingName, ReturnUrl }, "getSingngn");
    } catch (error) {
      console.error(error, "error");
    }
  };
  const OpenPDFFromB64InPdfViewer = () => {
    const { AuthToken, SrcPdfB64, signSettingName, returnUrl } = signingParams;

    if (!AuthToken || !SrcPdfB64) {
      alert("Please ensure both Bearer Token and PDF Base64 are provided.");
      return;
    }
    // Set the form action
    formRef.current.setAttribute("action", "https://digital.abmapplication.com/Console/PdfViewerSigning");

    // Submit the form
    formRef.current.submit();
  };
  if (loading) {
    return <Loader />;
  }
  console.log({ signingParams }, "signinngParams");

  return (
    <section className="groupContainer">
      <form>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Drawing")}</h2>
          </div>
        </div>

        <TableContainer component={Paper} sx={{ marginBottom: "20px" }}>
          <Table sx={{ minWidth: 650 }} aria-label="drawing details table">
            <TableHead sx={{ backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C", color: "#fff" }}>
              <TableRow sx={{ height: "20px" }}>
                {columns.map((column) => (
                  <TableCell key={column.id} sx={{ color: "#fff" }}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {drawingDetail.map((row, index) => (
                <TableRow key={index}>
                  {columns.map((column) => {
                    // Handle submission index separately
                    if (column.id === "submissionIndex") {
                      return <TableCell key={column.id}>Submission {index + 1}</TableCell>;
                    }

                    const value = row[column.accessor];

                    if (column.accessor === "submittedOn") {
                      return <TableCell key={column.id}>{value ? new Date(value).toLocaleString() : "N/A"}</TableCell>;
                    }

                    if (column.accessor === "updatedDxfFile" || column.accessor === "planReport") {
                      return (
                        <TableCell key={column.id}>
                          {value ? (
                            <FaFilePdf
                              color="#a10505"
                              style={{ width: "20px", height: "20px", cursor: "pointer" }}
                              onClick={() => window.open(value, "_blank")}
                            />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                      );
                    }

                    if (column.accessor === "dxfFile") {
                      return (
                        <TableCell key={column.id}>
                          {value ? (
                            <img
                              src={"https://i.imgur.com/GDoAGny.png"}
                              style={{ width: "20px", height: "30px", cursor: "pointer" }}
                              onClick={() => window.open(value, "_blank")}
                              alt="DXF File"
                            />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                      );
                    }
                    if (column.accessor === "signedPdfUrl") {
                      return (
                        <TableCell key={column.id}>
                          {formData?.IsSignedDrawingPdfURL === true && formData?.signedDrawingPdfURL ? (
                            <FaFilePdf
                              color="#24b155"
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                              onClick={() => window.open(formData.signedDrawingPdfURL, "_blank")}
                              title="View Signed PDF"
                            />
                          ) : !isEmployee ? (
                            <button
                              style={{
                                backgroundColor: "#157CB3",
                                color: "#fff",
                                padding: "8px 16px",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                                opacity: 1,
                              }}
                              type="button"
                              onClick={handleSign}
                              disabled={isEmployee}
                            >
                              Attach Digital Sign
                            </button>
                          ) : value ? (
                            <FaFilePdf
                              color="#a10505"
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                              onClick={() => handleOpenPdf(value, index)}
                            />
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                      );
                    }

                    return <TableCell key={column.id}>{value || "N/A"}</TableCell>;
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          style={{
            display: open ? "block" : "none",
            position: "fixed",
            top: 0,
            left: 0,
            width: "95%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              padding: "20px",
              background: "#fff",
              borderRadius: "5px",
              boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            }}
          >
            <p style={{ margin: "15px" }}>By clicking on the Submit button, you will be redirected to the Third-Party Page.</p>
            <form
              id="PDFViewerDemo"
              method="POST"
              //target="_blank"
              ref={(el) => (formRef.current = el)}
              onSubmit={handleSubmit(onSubmit)}
              action="https://digital.abmapplication.com/Console/PdfViewerSigning"
            >
              <input type="hidden" id="AuthToken" name="AuthToken" value={signingParams.AuthToken} />
              <input type="hidden" id="SignSettingName" name="SignSettingName" value={signingParams.SignSettingName} />
              <input type="hidden" id="SrcPdfB64" name="SrcPdfB64" value={signingParams.SrcPdfB64} />
              <input type="hidden" id="SrcPdfPath" name="SrcPdfPath" value="" />
              <input type="hidden" id="SignedPdfPath" name="SignedPdfPath" value="" />
              <input type="hidden" id="UserDataJson" name="UserDataJson" value={signingParams.UserDataJson} />
              <input
                type="hidden"
                id="ReturnUrl"
                name="ReturnUrl"
                value={signingParams.ReturnUrl || "https://cors.signer.digital/Home/PdfViewerSignResponse"}
              />

              <div class="button-inline">
                <div style={{ textAlign: "right" }}>
                  <button
                    type="button"
                    onClick={handleClose}
                    style={{ backgroundColor: "#0E7693", color: "#fff", marginLeft: "10px", padding: "5px", borderRadius: "3px" }}
                  >
                    Cancel
                  </button>
                  <button
                    value="Submit"
                    type="submit"
                    onClick={OpenPDFFromB64InPdfViewer}
                    style={{ backgroundColor: "#0E7693", color: "#fff", marginLeft: "10px", padding: "5px", borderRadius: "3px" }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {!isEmployee && !isNocModule && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              {/* <ButtonWrapper 
              variant="contained" 
              color="success" 
              size="medium" 
              label="Save" 
              type="submit" 
              sx={{ backgroundColor: "#157CB3" }} 
            /> */}
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Save"
                type="button"
                onClick={() => handleTabChange(3)}
                sx={{ backgroundColor: "#157CB3" }}
              />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};

export default Step4;
